import * as React from 'react'

import { IItemCard } from '../interface'

import LockupLastUpdated from '../lockupLastUpdated'
import LockupActionPanel from '../lockupListActionPanel'
import LockupPrice from '../lockupPrice'
import LockupRating from '../lockupRating'
import LockupSales from '../lockupSales'

import * as styles from './itemCardSidebar.module.css'

interface IProps extends IItemCard {
  children: React.ReactNode
}

const ItemCardSidebar = (props: IProps) => {
  return (
    <section className={styles.root}>
      <section className={styles.actionPanel}>
        <LockupActionPanel {...props} />
      </section>
      <section className={styles.itemMeta}>
        <LockupPrice priceInCents={props.item.price_cents} />
        <LockupRating {...props} />
        <LockupSales {...props} />
        <LockupLastUpdated {...props} />
      </section>
      <section className={styles.cartButtons}>{props.children}</section>
    </section>
  )
}

export default ItemCardSidebar
